import { CustomerSraDepartment } from "@teamprevent/common/customerSraDepartment/model";

import { CustomerSraDepartmentsAction } from "./actions";
import * as actionTypes from "./actionTypes";

export function reducer(state: CustomerSraDepartment[] = null, action: CustomerSraDepartmentsAction) {
    switch (action.type) {
        case actionTypes.LOAD_CUSTOMER_SRA_DEPARTMENTS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}
